import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GoogleMapsConfigService, IGmapData } from '@services/google-maps-config.service';

@Component({
  selector: 'app-retailer-gmap',
  templateUrl: './retailer-gmap.component.html',
  styleUrls: ['./retailer-gmap.component.scss'],
})
export class RetailerGmapComponent implements OnInit {
  @Input() data?: IGmapData;
  @Input() loading!: BehaviorSubject<boolean>;

  isGoogleMapsLoaded = false;
  mapOptions: any = {};
  mapMarkerOptions: any = {};

  constructor(private googleMapsConfig: GoogleMapsConfigService) {}

  ngOnInit(): void {
    this.initializeGoogleMaps();
  }

  private async initializeGoogleMaps(): Promise<void> {
    try {
      const config = await this.googleMapsConfig.getCompleteConfig();
      this.mapOptions = config.options;
      this.mapMarkerOptions = config.markerOptions;
      this.isGoogleMapsLoaded = true;
    } catch (error) {
      console.error('Failed to load Google Maps in RetailerGmapComponent:', error);
    }
  }

  viewMap(val: { lat: number; lng: number }) {
    this.googleMapsConfig.openInGoogleMaps(val);
  }
}
